import apiClient from '../client';

/**
 * Get all size weights for a company
 * @param {number} companyId 
 * @param {boolean} includeAll - If true, returns all size categories (with or without weights)
 */
export const getCompanySizeWeights = async (companyId, includeAll = true) => {
  const response = await apiClient.get(`/wholesale/companies/${companyId}/size-weights`, {
    params: { include_all: includeAll }
  });
  return response.data?.data || response.data;
};

/**
 * Get weight for a specific size category
 * @param {number} companyId 
 * @param {number} sizeCategoryId 
 */
export const getCompanySizeWeight = async (companyId, sizeCategoryId) => {
  const response = await apiClient.get(`/wholesale/companies/${companyId}/size-weights/${sizeCategoryId}`);
  return response.data?.data || response.data;
};

/**
 * Set weight for a size category (create or update)
 * @param {number} companyId 
 * @param {number} sizeCategoryId 
 * @param {object} data - { weight_per_carton, pieces_per_carton?, sqm_per_carton?, notes? }
 */
export const setCompanySizeWeight = async (companyId, sizeCategoryId, data) => {
  const response = await apiClient.put(`/wholesale/companies/${companyId}/size-weights/${sizeCategoryId}`, data);
  return response.data?.data || response.data;
};

/**
 * Delete weight configuration for a size category
 * @param {number} companyId 
 * @param {number} sizeCategoryId 
 */
export const deleteCompanySizeWeight = async (companyId, sizeCategoryId) => {
  const response = await apiClient.delete(`/wholesale/companies/${companyId}/size-weights/${sizeCategoryId}`);
  return response.data;
};

/**
 * Calculate tonnage for order items
 * @param {number} companyId 
 * @param {Array} items - Array of { size_category_id, quantity }
 */
export const calculateTonnage = async (companyId, items) => {
  const response = await apiClient.post(`/wholesale/companies/${companyId}/calculate-tonnage`, { items });
  return response.data?.data || response.data;
};
